import { render, staticRenderFns } from "./goods-code-label.vue?vue&type=template&id=74d3af0f&scoped=true"
import script from "./goods-code-label.vue?vue&type=script&lang=js"
export * from "./goods-code-label.vue?vue&type=script&lang=js"
import style0 from "./goods-code-label.vue?vue&type=style&index=0&id=74d3af0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d3af0f",
  null
  
)

export default component.exports